export const TRL = ["TRL | Sports Injury Physiotherapy", "TRL | Back & Spine Physiotherapy", "TRL | Knee Pain Physiotherapy"];
export const LAUNCH = new Date("2026-11-03T16:19:00Z");
export const RANGES = [["launch", "Since launch (3 Nov)"], ["7d", "Last 7 days"], ["30d", "Last 30 days (whole account)"]];

const sum = (rows, k) => rows.reduce((a, r) => a + (r[k] || 0), 0);

export const totalsOf = (rows) => {
  const cost = sum(rows, "cost"), clicks = sum(rows, "clicks"), impressions = sum(rows, "impressions"), conversions = sum(rows, "conversions");
  return { cost: Math.round(cost * 100) / 100, clicks, impressions, conversions: Math.round(conversions * 100) / 100,
    cost_per_conversion: conversions ? Math.round((cost / conversions) * 100) / 100 : null, ctr: impressions ? Math.round((clicks / impressions) * 10000) / 100 : 0 };
};

const byAdGroup = (kws) => Object.values(kws.reduce((acc, k) => {
  const key = `${k.campaign}|${k.ad_group}`;
  const g = (acc[key] ||= { name: k.ad_group, campaign: k.campaign, status: "", cost: 0, clicks: 0, impressions: 0, conversions: 0 });
  ["cost", "clicks", "impressions", "conversions"].forEach((m) => { g[m] += k[m] || 0; });
  return acc;
}, {})).map((g) => ({ ...g, ...totalsOf([g]) }));

// View-only filter of the stored snapshot; stored history is untouched (audit + optimiser still read all of it).
export const scopedSnapshot = (s, range) => {
  if (range === "30d") return { scope: "Whole account · last 30 days", totals: s.totals, campaigns: s.campaigns, ad_groups: s.ad_groups, keywords: s.keywords, search_terms: s.search_terms, locations: s.locations };
  const trl = (r) => TRL.includes(r.campaign ?? r.name);
  if (range === "7d") {
    const meta = Object.fromEntries(s.campaigns.map((c) => [c.id, c]));
    const camps = (s.campaigns_7d || []).filter(trl).map((c) => ({ ...meta[c.id], ...c }));
    const kws = (s.keywords_7d || []).filter(trl);
    return { scope: "New campaigns · last 7 days", totals: totalsOf(camps), campaigns: camps, ad_groups: byAdGroup(kws),
      keywords: kws.map((k) => ({ ...k, ...(s.keywords.find((x) => x.id === k.id && x.ad_group === k.ad_group) || {}), ...k })), search_terms: (s.search_terms_7d || []).filter(trl), locations: s.locations.filter(trl) };
  }
  const camps = s.campaigns.filter(trl);
  const old = Date.now() - LAUNCH.getTime() > 30 * 864e5;
  return { scope: old ? "New campaigns · last 30 days" : "New campaigns · since launch", totals: totalsOf(camps), campaigns: camps,
    ad_groups: s.ad_groups.filter(trl), keywords: s.keywords.filter(trl), search_terms: s.search_terms.filter(trl), locations: s.locations.filter(trl) };
};

export const RangePicker = ({ range, setRange, testid = "data-range" }) => (
  <div className="flex flex-wrap gap-2" data-testid={`${testid}-selector`}>
    {RANGES.map(([k, label]) => <button key={k} data-testid={`${testid}-${k}`} onClick={() => setRange(k)} className={`cc-btn px-3 py-1.5 text-xs ${range === k ? "cc-btn-primary" : "cc-btn-ghost"}`}>{label}</button>)}
  </div>
);
